import { Typography, Box, IconButton as BaseIconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Card as CardBase } from '../Card/Card';
import { withDefaults } from '../../../../utils/withDefaults';
const TextRoot = styled(Typography)(({
  theme
}) => ({
  color: theme.palette.grey[700]
}));
export const Text = withDefaults(TextRoot, {
  variant: 'Lato Body 2'
});
const ImageRoot = styled('img')({
  height: 'auto',
  objectFit: 'contain'
});
export const Image = withDefaults(ImageRoot, {
  src: '/privadent/meditation.png'
});
export const Card = styled(CardBase)(({
  theme
}) => ({
  backgroundColor: theme.palette.highlight1[50]
}));
export const Content = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2)
}));
export const IconButton = styled(BaseIconButton)({
  padding: 0,
  '&:hover': {
    backgroundColor: 'transparent'
  }
});